import React from 'react'
import { Aside, ChatArea } from '../../components'

function Workspace () {
  return (
    <div className='boxWrapper'>
      <Aside />
      <ChatArea />
    </div>
  )
}

export default Workspace
